import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modals: {
    view: {
      open: false,
      id: null,
    },
    delete: {
      open: false,
      id: null,
    },
    resend: {
      open: false,
      id: null,
    },
  },
};

const emailNotificationsControlSlice = createSlice({
  name: "emailNotificationsControl",
  initialState: initialState,
  reducers: {
    openModal: (state, action) => {
      const { id, modalType } = action.payload;
      state.modals[modalType] = { open: true, id };
    },
    closeModal: (state, action) => {
      const { modalType } = action.payload;
      state.modals[modalType] = { open: false, id: null };
    },
  },
});

export const { openModal, closeModal } = emailNotificationsControlSlice.actions;
export default emailNotificationsControlSlice.reducer;
